/** @format */

const GA4_LOGIN_TRACKED_KEY = 'ga4_login_event_tracked';

/**
 * True when the app was opened with an OAuth authorization response from Keycloak
 * (user just returned from login), not on a normal reload with an existing session.
 *
 * Must be evaluated before keycloak.init() clears hash/query params.
 */
export function isKeycloakAuthRedirect(href: string = window.location.href): boolean {
  let url: URL;

  try {
    url = new URL(href);
  } catch {
    return false;
  }

  if (url.pathname.includes('silent-check-sso')) {
    return false;
  }

  const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
  const searchParams = new URLSearchParams(url.search);

  const hasAuthCode = hashParams.has('code') || searchParams.has('code');
  const hasAccessToken = hashParams.has('access_token') || searchParams.has('access_token');

  return hasAuthCode || hasAccessToken;
}

/**
 * True only on the first Keycloak OAuth callback per browser tab session.
 * Skips repeat SSO round-trips on reload (login-required returns a new code each time).
 */
export function shouldTrackKeycloakLogin(href: string = window.location.href): boolean {
  if (!isKeycloakAuthRedirect(href)) {
    return false;
  }

  return sessionStorage.getItem(GA4_LOGIN_TRACKED_KEY) !== '1';
}

export function markKeycloakLoginTracked(): void {
  sessionStorage.setItem(GA4_LOGIN_TRACKED_KEY, '1');
}

export function clearKeycloakLoginTracked(): void {
  sessionStorage.removeItem(GA4_LOGIN_TRACKED_KEY);
}
